import { createContext } from "react";

interface PageContextType {
  title: string;
  subtitle: string;
  setTitle: (arg0: string) => void;
  setSubtitle: (arg0: string) => void;
}

export const PageContext = createContext<PageContextType>({
  title: "",
  subtitle: "",
  setTitle: () => {},
  setSubtitle: () => {},
});
